import type { Rect } from "../types/C1_AppTypes";

/** Returns the axis-aligned model bounds of a potentially rotated furniture item. */
export function furnitureBounds(
  modelX: number,
  modelY: number,
  width: number,
  height: number,
  rotation: number,
  originXRatio: number,
  originYRatio: number,
): Rect {
  const left = -width * originXRatio;
  const top = -height * originYRatio;
  const radians = (rotation * Math.PI) / 180;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const corners = [
    { x: left, y: top },
    { x: left + width, y: top },
    { x: left + width, y: top + height },
    { x: left, y: top + height },
  ];
  const bounds: Rect = { x1: Infinity, y1: Infinity, x2: -Infinity, y2: -Infinity };
  for (const corner of corners) {
    const x = modelX + corner.x * cos - corner.y * sin;
    const y = modelY + corner.x * sin + corner.y * cos;
    bounds.x1 = Math.min(bounds.x1, x);
    bounds.y1 = Math.min(bounds.y1, y);
    bounds.x2 = Math.max(bounds.x2, x);
    bounds.y2 = Math.max(bounds.y2, y);
  }
  return bounds;
}

